var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.centerDialogVisible
    ? _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "活动配置",
            visible: _vm.centerDialogVisible,
            width: "800px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "up-contents" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择活动", prop: "id" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "选择活动" },
                          model: {
                            value: _vm.ruleForm.id,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "id", $$v)
                            },
                            expression: "ruleForm.id",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleOptionClick(item)
                              },
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上传活动背景图片", prop: "url" } },
                    [
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loadingImage,
                              expression: "loadingImage",
                            },
                          ],
                          class: { hide: _vm.url.length == 1 },
                          attrs: {
                            "element-loading-text": "正在上传...",
                            action: "#",
                            "on-preview": _vm.handlePictureCardPreview,
                            "file-list": _vm.url,
                            "list-type": "picture-card",
                            "before-upload": (file) => {
                              return _vm.handleBeforeUpload(file, _vm.w, _vm.h)
                            },
                            "http-request": (file) => {
                              return _vm.uploadFile(file, "url")
                            },
                            "before-remove": (file, fileList) => {
                              return _vm.deleteFile(file, fileList, "url")
                            },
                            limit: 1,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus",
                            attrs: { slot: "trigger" },
                            slot: "trigger",
                          }),
                        ]
                      ),
                      _c("div", { staticStyle: { "margin-top": "20px" } }, [
                        _vm._v(
                          "请上传尺寸为：" +
                            _vm._s(_vm.w) +
                            "x" +
                            _vm._s(_vm.h) +
                            "的图片"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "跳转链接", prop: "href" } },
                    [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入跳转链接",
                              clearable: "",
                            },
                            model: {
                              value: _vm.ruleForm.href,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "href", $$v)
                              },
                              expression: "ruleForm.href",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.centerDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.tianku } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }